<template>
  <div class="app" id="login-page">
    <div class="forgetPassword-form">
      <div class="content-w3ls">
        <div class="content-agile1">
          <div class="content-logo">
            <img src="../../img/logo.png" alt="logo" />
            <h3>TRANG QUẢN TRỊ</h3>
          </div>
        </div>
        <div class="content-agile2">
          <div class="title-login text-center">quên mật khẩu</div>
          <div class="form-recoverPassword">
            <el-form
              ref="myForm"
              :model="mData.dataForm"
              :rules="mData.validForm"
              label-width="120px"
              label-position="top"
              @submit.native.prevent
            >
              <b-alert
                style="padding: 10px"
                variant="danger"
                dismissible
                :show="mData.dataDefault.showDismissibleAlert"
                @dismissed="mData.dataDefault.showDismissibleAlert = false"
                >{{ mData.dataDefault.error }}</b-alert
              >
              <b-alert
                style="padding: 10px"
                variant="success"
                dismissible
                :show="mData.dataDefault.showSuccessAlert"
                @dismissed="mData.dataDefault.showSuccessAlert = false"
                >{{ mData.dataDefault.success }}</b-alert
              >
              <el-form-item label="Tên đăng nhập" prop="account">
                <el-input
                  v-model="mData.dataForm.account"
                  size="medium"
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-show="recoverPasswordNextBtn"
                class="form-btn"
                style="margin-bottom: 0"
              >
                <el-button @click="fn_back()" plain>Quay lại</el-button>
                <el-button
                  type="primary"
                  class="btn-next"
                  native-type="submit"
                  v-ladda
                  @click="fn_recoverPasswordNext()"
                  >Tiếp tục</el-button
                >
              </el-form-item>
              <div v-if="showResetPassword">
                <el-form-item label="Mã code" prop="code">
                  <el-input
                    type="text"
                    size="medium"
                    v-model="mData.dataForm.code"
                    @input="forceUpdateUI"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Mật khẩu mới">
                  <el-input
                    type="password"
                    size="medium"
                    v-model="mData.dataForm.newPassword"
                    show-password
                    autocomplete="nope"
                    @input="forceUpdateUI"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  class="text-center form-btn"
                  style="margin-bottom: 0"
                >
                  <el-button
                    type="primary"
                    class="btn-next"
                    native-type="submit"
                    v-ladda
                    @click="fn_submitForm()"
                    >Đồng ý</el-button
                  >
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";

export default {
  data() {
    return {
      aLang: LanguageService.vi,
      showResetPassword: false,
      recoverPasswordNextBtn: true,
      mData: {
        dataDefault: {
          error: "",
          success: "",
          showDismissibleAlert: false,
          showSuccessAlert: false,
        },
        dataForm: {
          account: "",
          code: "",
          newPassword: "",
        },
        validForm: {
          account: [ValidService.required],
          code: [ValidService.required],
          newPassword: [ValidService.required],
        },
      },
    };
  },
  methods: {
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_recoverPasswordNext() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          AuthService.recoverPassword(this.mData.dataForm.account)
            .then(() => {
              this.mData.dataDefault.showDismissibleAlert = false;
              window.toastr.success(
                "Đổi mật khẩu thành công. Vui lòng kiểm tra email để lấy mã code"
              );
              this.showResetPassword = true;
              this.recoverPasswordNextBtn = false;
            })
            .catch((error) => {
              if (error.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (error.code === 2) {
                window.toastr.error("Gặp sự cố tải dữ liệu");
              } else {
                window.toastr.error("Đã có lỗi xảy ra");
              }
              MethodService.stopLadda();
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_submitForm() {
      this.mData.dataDefault.showSuccessAlert = false;
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          AuthService.resetPassword(
            this.mData.dataForm.account,
            this.mData.dataForm.code,
            this.mData.dataForm.newPassword
          )
            .then(() => {
              this.$router.push({ name: "Admin-Home" });
            })
            .catch((e) => {
              console.log(e.code, e.message);
              if (e.code === -1) {
                this.showResetPassword = false;
                this.recoverPasswordNextBtn = true;
                window.toastr.error(LanguageService.lang.c_changeCodeError);
              } else if (e.code === 401) {
                this.showResetPassword = false;
                this.recoverPasswordNextBtn = true;
                window.toastr.error(
                  LanguageService.lang.c_changePasswordLength
                );
              } else if (e.code === 4) {
                window.toastr.error(LanguageService.lang.no_connection);
              } else {
                this.showResetPassword = false;
                this.recoverPasswordNextBtn = true;
                window.toastr.error(LanguageService.lang.c_resetPasswordError);
                this.mData.dataDefault.showDismissibleAlert = true;
              }
              MethodService.stopLadda();
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_back() {
      this.$router.go(-1);
    },
  },
  mounted: function () {},
};
</script>
<style scoped>
@font-face {
  font-family: "Noh Carborne";
  src: url("../../fonts/TUV Noh Carbone.ttf");
}
.form-btn {
  margin: 15px 0;
  text-align: center;
}
.btn-next {
  min-width: 150px;
  background-color: #9e1c1e;
  transition: 0.3s !important;
  color: #fff;
  border: 1px solid #9e1c1e;
}
.btn-next:hover {
  background-color: #e0ab45;
  border: 1px solid #e0ab45;
}

#login-page {
  background: url("../../img/gioi-thieu-background-grid.png") no-repeat center
      center,
    url("../../img/gioi-thieu-background-cloud.png") no-repeat center center,
    #9e1c1e;
  padding: 15px;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
}

ol,
ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}

img {
  max-width: 100%;
}

h1.w3ls {
  font-size: 40px;
  font-weight: 500;
  color: #9e1c1e;
  padding: 15px 0;
  text-align: center;
  text-transform: uppercase;
}
.forgetPassword-form {
  width: 100%;
}
.form-recoverPassword form {
  min-height: 349px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content-w3ls {
  display: block;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
  background-color: #fff;
  width: 100%;
  position: relative;
}
.content-w3ls::before {
  content: "";
  position: absolute;
  background: url("../../img/gioi-thieu-hoa-trai.png");
  background-repeat: no-repeat;
  width: 207px;
  height: 224px;
  z-index: 10;
  left: -93px;
  bottom: -105px;
  display: none;
}
.content-w3ls::after {
  content: "";
  position: absolute;
  background: url("../../img/hoa-phai.png");
  background-repeat: no-repeat;
  width: 207px;
  height: 224px;
  z-index: 10;
  right: -202px;
  top: 68px;
  display: none;
}
.content-agile1 {
  background-color: #fff1dc;
  width: 50%;
  display: none;
  justify-content: center;
}
.content-agile2 {
  width: 100%;
}
.content-agile1,
.content-agile2 {
  position: relative;
}
.content-agile1::before,
.content-agile2::before {
  position: absolute;
  content: "";
  height: 13px;
  background: linear-gradient(
    180deg,
    #f9bc60 0%,
    #ffca78 20.31%,
    #fed9b7 53.12%,
    #fac96a 76.04%,
    #e0ab45 100%
  );
  left: 0;
  bottom: 0;
  width: 100%;
}
.content-logo {
  background-color: #003168;
  width: 250px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 0 10px 0;
}
.content-logo h3 {
  font-size: 25px;
  font-family: "Noh Carborne";
  background: linear-gradient(
    270deg,
    #f9bc60 9.85%,
    #fed9b7 20.64%,
    #ffca78 42.94%,
    #fac766 55.11%,
    #fac96a 65.75%,
    #ffce87 84.81%,
    #e0ab45 99.18%
  );
  -webkit-background-clip: text;
  padding: 15px;
  margin-top: 20px;
  background-clip: text;
  color: transparent;
}

.title-login {
  background: #fff1dc;

  color: #9e1c1e;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 25px;
  padding: 30px 30px;
}
.content-w3ls .content-agile2 .el-form {
  padding: 30px 40px;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #9e1c1e;
}

/*-- responsive design --*/
@media (min-width: 991px) {
  .content-w3ls {
    display: flex;
  }
  .content-w3ls::before,
  .content-w3ls::after {
    display: block;
  }
  .content-agile1 {
    display: flex;
  }
  .content-agile2 {
    width: 50%;
  }
  #login-page {
    align-items: center;
  }
  .forgetPassword-form {
    max-width: 900px;
    /* min-height: 349px; */
  }
}
</style>
